import {
    HStack,
    Text,
    Box,
    Button,
    useToast,
    Image,
} from "@chakra-ui/react";
import { Trash, Pencil, PaperPlaneRight, Plus } from "phosphor-react";
import { ModalComponent } from "../../Components/Common/UI";
import React, { useState } from "react";
import { COLORS } from "../../Helper/Colors";
import TableStyle from "../../Components/Common/TableStyle";
import ProfileImage from "../../Assets/profile_placeholder.jpg"
import {
    DeleteModal,
} from "../../Components/Common/UI";
import TableV6 from "../../Components/Common/TableV6";
import Api from "../../Helper/ApiHandler";
import { useQuery } from "react-query";
import { useDebounce } from "../../Helper/Hooks/useDebounce";
import { useLocation } from "react-router-dom";
import { AddEditNotificationModal } from "./AddEditNotificationModal";
import { SendNotificationModal } from "./SendNotificationModal";

const UserTable = () => {
    const { state, pathname } = useLocation();
    const api = new Api();
    const toast = useToast();
    const [search, setSearch] = useState("");
    const [params, setParams] = useState({
        pageNo: 1,
        pageSize: 25,
        order: "DESC",
        sortBy: "id",
    });
    const [type, setType] = useState("");
    const [changeId, setChangeId] = useState(null);
    const [deleteBtnLoading, setDeleteBtnLoading] = useState(false);
    const [addNotificationModal, setAddNotificationModal] = useState(false);
    const [sendNotificationModalOpen, setSendNotificationModalOpen] = useState(false);
    const [data, setData] = useState([]);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [deleteId, setDeleteId] = useState(null);
    const [initialValues, setInitialValue] = useState("");
    const debouncedSearchTerm = useDebounce(search, 1000);
    let addDefaultSrc = (ev) => {
        ev.target.src = ProfileImage;
    };


    const fetchNotification = async ({ queryKey }) => {
        const notificationList = await api.post(`${"notification/list"}`, {
            page: state?.count ? state.pageNo : queryKey[2].pageNo,
            search: state?.count ? state.search : queryKey[1],
            order: state?.count ? state.order : queryKey[2].order,
            sortBy: state?.count ? state.sortBy : queryKey[2].sortBy,
        });

        setData(notificationList?.data);
        return notificationList;
    };


    const {
        isLoading,
        data: notificationData,
        refetch,
    } = useQuery(["notificationLists", debouncedSearchTerm, params], fetchNotification,
    );


    const handleNotificationModalClose = () => {

        setAddNotificationModal(false);
    }
    const handleSendNotificationModalClose = () => {

        setSendNotificationModalOpen(false);
    }

    const handleDelete = async (type) => {
        if (type === "CANCEL") {
            setIsDeleteModalOpen(false);
            return;
        }
        try {
            setDeleteBtnLoading(true);
            await api.post("notification/delete", { id: String(deleteId) });
            setIsDeleteModalOpen(false);
            setDeleteBtnLoading(false);
            setDeleteId(null);
            toast({
                description: "notification has been deleted.",
                status: "success",
                duration: 3000,
                position: "top",
            });

            if (params.pageNo > 1 && notificationData?.data?.length === 1) {
                setParams({ ...params, pageNo: params.pageNo - 1 });
            } else {
                await refetch();
            }
        } catch (error) {
            toast({
                description: error.message,
                status: "error",
                duration: 3000,
                position: "top",
            });
            setDeleteBtnLoading(false);
        }
    };

    const columns = [
        {
            Header: () => (
                <Box>
                    <Text>Image</Text>
                </Box>
            ),
            accessor: "photo",
            Cell: (row) => (
                <Box display={"flex"} justifyContent={"center"}>
                    <Image
                        onError={addDefaultSrc}
                        borderRadius="full"
                        boxSize="45px"
                        src={row.value ? row.value : ProfileImage}
                        alt="Img"
                    />
                </Box>
            ),
            sortable: false,
        },
        {
            Header: () => (
                <Box>
                    <Text marginLeft={"5px"}>title</Text>
                </Box>
            ),
            accessor: "title",
            Cell: (row) => (

                <Text textAlign={"center"}>
                    {row.value}
                </Text>
            ),
            sortable: false,

        },
        {
            Header: () => (
                <Box>
                    <Text marginLeft={"5px"}>content</Text>
                </Box>
            ),
            accessor: "content",
            Cell: (row) => (

                <Box textAlign={"center"} textTransform={"none"}>
                    {row.value}
                </Box>
            ),
            sortable: false

        },

        {
            Header: () => (
                <Box>
                    <Text borderColor={"white"} boxShadow="none" marginLeft={"10px"}>
                        Action
                    </Text>
                </Box>
            ),
            accessor: "_id",
            Cell: (row) => (
                <>
                    <HStack
                        alignItems={"center"}
                        justifyContent="center"
                        textAlign={"center"}
                    >
                        <Button
                            backgroundColor={COLORS.brand}
                            color={"white"}
                            title="Send Notification"
                            _hover={{ backgroundColor: COLORS.brand }}
                            rightIcon={<PaperPlaneRight size={18} />}
                            isLoading={false}
                            onClick={() => {
                                setSendNotificationModalOpen(true)

                            }}
                        >
                            Send
                        </Button>
                        <Button
                            backgroundColor={COLORS.brand}
                            color={"white"}
                            title="Edit"
                            _hover={{ backgroundColor: COLORS.lightPink }}
                            onClick={() => {
                                setAddNotificationModal(true);
                                setInitialValue(row.original)
                                setType("EDIT")
                            }}
                        >
                            <Pencil size={20} />
                        </Button>
                        <Button
                            backgroundColor={COLORS.brand}
                            color={"white"}
                            title="Delete"
                            _hover={{ backgroundColor: COLORS.lightPink }}
                            onClick={() => {
                                setDeleteId(row.original._id);
                                setIsDeleteModalOpen(true);
                            }}
                        >
                            <Trash size={20} />
                        </Button>




                    </HStack>
                </>
            ),
            sortable: false,
        },
    ];

    return (
        <>
            <HStack
                display={"flex"}
                justifyContent={"flex-end"}
                padding={"8px"}

            >
                <Button
                    backgroundColor={COLORS.brand}
                    color={"white"}
                    title="Send Notification"
                    _hover={{ backgroundColor: COLORS.brand }}
                    leftIcon={<Plus size={18} />}
                    onClick={() => {
                        setInitialValue("")
                        setAddNotificationModal(true)
                        setType("ADD")
                    }}

                >
                    Add Notification
                </Button>
            </HStack>
            <TableStyle version={6}>
                <TableV6
                    columns={columns}
                    data={data}
                    // handleSortBy={handleSortBy}
                    isLoading={isLoading}
                    key={"master-rep-table"}
                />

            </TableStyle>

            <DeleteModal
                heading={"Delete Notification"}
                isOpen={isDeleteModalOpen}
                onCancel={() => handleDelete("CANCEL")}
                onDelete={() => handleDelete("DELETE")}
                deleteBtnLoading={deleteBtnLoading}
            />
            <ModalComponent
                isOpen={addNotificationModal}
                onClose={handleNotificationModalClose}
                size="2xl"


            >
                <AddEditNotificationModal type={type} initialValues={initialValues} onClose={handleNotificationModalClose} />

            </ModalComponent>
            <ModalComponent
                isOpen={sendNotificationModalOpen}
                onClose={handleSendNotificationModalClose}
                size="4xl"


            >
                <SendNotificationModal type={type} onClose={handleSendNotificationModalClose} />

            </ModalComponent>
        </>
    );
}

export default UserTable;